export const PERMISSION_DENIED_MESSAGE = "Permission denied.";

function getHttpStatus(err: unknown): number | undefined {
  if (!err || typeof err !== "object" || !("httpStatus" in err)) {
    return undefined;
  }
  const status = (err as { httpStatus?: unknown }).httpStatus;
  return typeof status === "number" ? status : undefined;
}

/** Prefer the API message, except 403 which always uses Permission denied. */
export function resultLoadErrorMessage(
  err: unknown,
  fallback: string,
): string {
  if (getHttpStatus(err) === 403) {
    return PERMISSION_DENIED_MESSAGE;
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message;
  }
  return fallback;
}
